module.exports = {
    ACCOUNTSURL: 'accounts',
    CARDSURL: 'cards',
    LOANSANDMORTGAGESURL: 'loans-mortgages',
    DEPOSITSURL: 'deposits',
    INVESTMENTSURL: 'investments'
};